import React from 'react'
import { Formik } from "formik";
import * as Yup from 'yup';
const SchemaSorteos = Yup.object({
    cantidad: Yup.number().required("La cantidad es requerida.").min(1,"La cantidad debe de ser mayor a 0.")
});
export default function RegistroCaptura(props) {
    const{Cantidad,Edit}=props;
    const Close=()=>{
        $('#addSorteo').modal('hide');
    }
    return (
        <Formik
            initialValues={{
                cantidad: Cantidad.cantidad,
                id:Cantidad.id
            }}
            validationSchema={SchemaSorteos}
            enableReinitialize="true"
            onSubmit={(values, actions) => {
                //alert("pass");
                Edit(values, actions);
            }}>
            {({
                values,
                errors,
                status,
                setFieldValue,
                handleBlur,
                handleChange,
                handleSubmit,
                resetForm
            }) => <div className="modal" id="addSorteo" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Cantidad de registro</h5>
                                <button type="button" className="btn-close" onClick={()=> $('#addSorteo').modal('hide')} aria-label="Close"></button>
                            </div>
                            <form onSubmit={handleSubmit} >
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <div className={errors.cantidad ? "form-group" : "form-group"}>
                                                <label htmlFor="exampleInputEmail1">Cantidad:</label>
                                                <input type="text" onChange={handleChange} value={values.cantidad || ""} className="form-control" name="cantidad" id="cantidad" autoComplete="none" />
                                                <span className="help-block">{errors.cantidad}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary"  onClick={() => {resetForm(),Close()}} >Cancelar</button>
                                    <button type='submit' className={`btn btn-primary`}>Agregar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            }
        </Formik>
    )
}
